import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { AlertMessagesVService } from '../../services/V3/padre';
import { withToast } from './Toast';

const GlobalAlerts = ({ errorToast }) => {
    const [alerts, setAlerts] = useState<any[]>([]);

    useEffect(() => {
        AlertMessagesVService.alertMessagesVGetGlobalAlerts()
        .then(x => setAlerts(x))
        .catch(err => errorToast(err))
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const sanitizedAlert = (alertMessage) => ({
        __html: DOMPurify.sanitize(alertMessage),
    });

    return (
        <>
            {alerts && alerts.length > 0 &&
                <Grid container className='global-alerts-bar' role="region" aria-label="Global alerts">
                    <Grid style={{ display: "flex", flexDirection: "column" }}>
                        {alerts.map((x, index) => 
                            <Grid style={{ margin: index + 1 !== alerts.length ? "5px 20px" : "0px 20px" }} role="status" aria-label="Alert notification">
                                <span dangerouslySetInnerHTML={sanitizedAlert(x)} />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            }
        </>
    );
}
export default withToast(GlobalAlerts);